import { SPEECH_LOCALE } from "@/lib/i18n";

export function speak(text, lang = "en") {
  if (!("speechSynthesis" in window) || !text) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = SPEECH_LOCALE[lang] || "en-IN";
  u.rate = 0.95;
  u.pitch = 1;
  window.speechSynthesis.speak(u);
}

export function stopSpeaking() {
  if ("speechSynthesis" in window) window.speechSynthesis.cancel();
}

export function createRecognizer(lang = "en", { onResult, onEnd } = {}) {
  const Rec = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!Rec) return null;
  const r = new Rec();
  r.lang = SPEECH_LOCALE[lang] || "en-IN";
  r.continuous = false;
  r.interimResults = false;
  r.maxAlternatives = 1;
  r.onresult = (e) => {
    const txt = e.results?.[0]?.[0]?.transcript || "";
    onResult && onResult(txt);
  };
  r.onend = () => { onEnd && onEnd(); };
  return r;
}
